'use client';

import { Button } from '@/ui/buttons/Button';
import React, { useEffect } from 'react';
import { useAppConfiguration } from '../hooks/useAppConfiguration';

export const AppSwitcher = () => {
  // do not render on server
  const [isMounted, setIsMounted] = React.useState(false);
  const { resertSettings } = useAppConfiguration();
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!isMounted) return <></>;

  // find cookie with alias
  const cookie = document?.cookie
    .split('; ')
    .find((row) => row.startsWith('alias='));
  if (!cookie) return <></>;

  return (
    <div className="text-text-secondary text-center">
      <div>
        You are currently viewing site:{' '}
        <span className="text-text-primary font-bold">
          {cookie.split('=')[1]}
        </span>
      </div>
      <div>
        <Button
          variant="destructiveSmall"
          onClick={() => {
            resertSettings();
            window.location.href = '/';
          }}
        >
          Go back to default site
        </Button>
      </div>
    </div>
  );
};
